/* eslint-disable complexity */
import { columnType } from 'components/table/types';
import _ from 'lodash';
import { Stack, Switch, TextField, useTheme } from '@mui/material';
import { CustomSwitch } from 'components/Inputs';
import { hasPermission } from 'components/AuthorizationComponent';
import { permissionEnums } from 'constants/permission.constants';
import { Flag } from 'theme/elements/icons';

export const tableData = (data: any) => {
	return data?.map((item: any) => ({
		...item,
	}));
};

export const tableColumns = {
	alpha2Code: 'custom',
	name: 'custom',
	alpha3Code: 'string',
	isForbidden: 'custom',
	isRisky: 'custom',
	isTaxShelter: 'custom',
};

export const buildColumns = (
	type: any,
	t: any,
	handleEditButtonClick: any,
	saveCountryChanges: any,
	cancelCountryChanges: any,
	updateModifiedCountries: any,
	dispatch?: any,
	tableData?: any,
	setTableData?: any
): columnType[] => {
	const theme = useTheme();
	const countriesEditPermissions = hasPermission([permissionEnums.EDIT_COUNTRIES]);

	const columns: columnType[] = [];
	_.keys(tableColumns).map((element: any, index: number) => {
		let customValueHandle = {};
		if (element === 'alpha2Code') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return <Flag title={_.lowerCase(String(value))} />;
				},
			};
		}
		if (element === 'isForbidden' || element === 'isRisky') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return (
						<CustomSwitch checked={element === 'isForbidden' ? !value : value} theme={theme}>
							<Switch
								checked={element === 'isForbidden' ? !value : value}
								disabled={!row?.editable}
								onChange={
									countriesEditPermissions
										? () => updateModifiedCountries(element, !value, row)
										: undefined
								}
							/>
						</CustomSwitch>
					);
				},
			};
		}
		if (element === 'isTaxShelter') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return (
						<Stack direction={'row'} justifyContent={'space-between'} gap={10}>
							<CustomSwitch checked={value} theme={theme}>
								<Switch
									checked={value}
									disabled={!row?.editable}
									onChange={
										countriesEditPermissions
											? () => updateModifiedCountries(element, !value, row)
											: undefined
									}
								/>
							</CustomSwitch>
							{row?.editable ? (
								<Stack gap={5} direction={'row'}>
									{countriesEditPermissions && (
										<>
											<img
												src={'icons/check.svg'}
												style={{
													cursor: row.name === '' ? 'auto' : 'pointer',
													opacity: row.name === '' ? 0.5 : 1,
												}}
												onClick={row.name === '' ? undefined : () => saveCountryChanges(row)}
											/>
											<img
												src={'icons/cancel.svg'}
												style={{ cursor: 'pointer' }}
												onClick={() => cancelCountryChanges()}
											/>
										</>
									)}
								</Stack>
							) : (
								<>
									{countriesEditPermissions && (
										<img
											src={'icons/pencil.svg'}
											style={{ cursor: 'pointer' }}
											onClick={() => handleEditButtonClick(row.id)}
										/>
									)}
								</>
							)}
						</Stack>
					);
				},
			};
		}
		if (element === 'name') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return (
						<>
							{row?.editable ? (
								<TextField
									sx={{
										'& .MuiInputBase-root': {
											maxHeight: '34px',
											border: value === '' ? '1px solid red' : 'auto',
										},
									}}
									value={value}
									onChange={
										countriesEditPermissions
											? (event: any) => {
													updateModifiedCountries(element, event?.target.value, row);
											  }
											: undefined
									}
								/>
							) : (
								value
							)}
						</>
					);
				},
			};
		}
		const props: columnType = {
			fieldId: 'id',
			name: element,
			title: t('page.countries_management.field.' + element),
			type: _.get(tableColumns, element),
			sortable: true,
			...customValueHandle,
		};
		columns.push(props);
	});
	return columns;
};
